var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['a-button-otg', _vm.themeClass],attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]}),_vm._t("icon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }